import { StateManager } from 'AppReact';

export default StateManager([
  { name: 'admin_preferences', isRemote: true, defaultValue: [] },
])
